
import ActivityDefinition from '@/models/activityDefinition';
import ActivityDefinitionState from '@/store/activityDefinition/activityDefinitionsState';
import ConfigState from '@/store/config/configState';
import { mapActions, mapState } from 'vuex';
import { OrchestrationRouteModel } from '@/models/orchestrationRouteModel';
import UserState from '@/store/user/userState';
import Vue from 'vue';
import { VueConstructor } from 'vue/types/vue';
import Workflow from '@/models/workflow';
import WorkflowsSidebar from '@/workflows/WorkflowsSidebar.vue';
import { WorkflowType, PipelinePhaseType, ActivityDefinitionType, EnumObject } from '../models/enums';

const WorkflowsComponent = (Vue as VueConstructor<Vue & ConfigState & UserState>).extend({
  created() {
    this.filter = 1;
    this.activityDefinitionTypes = this.enumToArray(ActivityDefinitionType);
    this.pipelinePhaseTypes = this.enumToArray(PipelinePhaseType);
  },

  data() {
    return {
      filter: 1,
      tableHeaders: [
        {
          text: 'Sequence',
          value: 'sequence',
          width: '100px',
        },
        {
          text: 'Id',
          value: 'id',
          width: '120px',
        },
        {
          text: 'Name',
          value: 'name',
          width: '280px',
        },
        {
          text: 'Phase',
          value: 'pipelinePhaseTypeId',
        },
      ],
      selectedDefinition: [] as ActivityDefinition[],
      activityDefinitionTypes: [] as EnumObject[],
      PipelinePhaseType: PipelinePhaseType,
      pipelinePhaseTypes: [] as EnumObject[],
    };
  },

  components: {
    WorkflowsSidebar,
  },

  computed: {
    ...mapState<ConfigState[]>('configStore', {
      orchestrationRouteModels: 'orchestrationRouteModels',
      workflows: 'workflows',
    }),
    ...mapState<ActivityDefinitionState[]>('activityDefinitionStore', {
      activityDefinitions: 'activityDefinitions',
    }),
    ...mapState<UserState>('userStore', {
      editor: 'editor',
    }),

    filteredDefinitions(): ActivityDefinition[] {
      let filtered = this.activityDefinitions
        ? this.activityDefinitions.filter((x) => x.workflowId.toString() === this.filter.toString())
        : [];
      filtered = this.sortArray(filtered, 'sequence');
      return filtered;
    },

    filteredWorkflows(): Workflow[] {
      let filtered = [] as Workflow[];
      if (this.workflows) {
        const sortedWorkflows = this.sortArray(this.workflows, 'sortOrder');
        sortedWorkflows?.forEach((w) => {
          if (!w.editorOnly || this.editor == true) {
            filtered.push(w);
          }
        });
      }

      return filtered;
    },

    localSelectedDefinition(): ActivityDefinition | undefined {
      if (this.selectedDefinition.length > 0) {
        return this.activityDefinitions?.find((x) => x.id === this.selectedDefinition[0].id) as ActivityDefinition;
      } else {
        return undefined;
      }
    },
  },

  watch: {
    orchestrationRouteModels() {
      if (this.localSelectedDefinition) {
        const orchRoutes = this.orchestrationRouteModels as OrchestrationRouteModel[];
        const route = orchRoutes.find(
          (x) => x.id === (this.localSelectedDefinition as ActivityDefinition).orchestrationRouteId,
        );
        if (route) {
          this.localSelectedDefinition.orchestrationRouteModel = undefined;
          this.localSelectedDefinition.orchestrationRouteModel = route;
          this.commitActivityDefinition(this.localSelectedDefinition);
        }
      }
    },
    activityDefinitions: {
      handler() {
        const item = this.localSelectedDefinition;
        if (item && item.orchestrationRouteModel === undefined && item.orchestrationRouteId !== 0) {
          if (this.orchestrationRouteModels) {
            const orchRouteModel = this.orchestrationRouteModels.find((x) => x.id === item.orchestrationRouteId);
            item.orchestrationRouteModel = orchRouteModel;
            this.commitActivityDefinition(item);
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('activityDefinitionStore', ['commitActivityDefinition']),

    rowClick(
      item: ActivityDefinition,
      row: {
        select: (value: boolean) => void;
      },
    ) {
      if (item.orchestrationRouteModel === undefined) {
        if (this.orchestrationRouteModels) {
          const orchRouteModel = this.orchestrationRouteModels.find((x) => x.id === item.orchestrationRouteId);
          item.orchestrationRouteModel = orchRouteModel;
          this.commitActivityDefinition(item);
        }
      }
      row.select(true);
    },

    getWorkflowTypeName(type: number) {
      return WorkflowType[type];
    },

    changeFilter(newFilter: number) {
      this.filter = newFilter;
      this.selectedDefinition = [];
    },
  },
});

export default WorkflowsComponent;
